export class TaskStatus {
    id: number;
    name: string;
    code: string;

    toString() {
        return this.name;
    }
}